import Alpine from "alpinejs";
import tabsApp from "./tabs.js";
import profileApp from "./profile.js";
import contactFormApp from "./contact-form.js";
import schoolApp from "./school.js";

export function registerMyAccountComponents() {
  Alpine.data("myAccountApp",  tabsApp);
  Alpine.data("myAccountProfileFormApp", profileApp);
  Alpine.data("myAccountContactFormApp", contactFormApp);
  Alpine.data("myAccountSchoolApp", schoolApp);
}